import { scopedTranslation } from '@utils/I18n'
import { Alert } from '@atoms'

import useSupporterFilteringStore from '../filter-supporters/stores/useSupporterFilteringStore'

const tGroupShow = scopedTranslation('group_show')

type SearchSummaryBarProps = {
  searchLoading: boolean
  matchingCount: number
}

function SearchSummaryBar({ searchLoading, matchingCount }: SearchSummaryBarProps) {
  const activeFilters = useSupporterFilteringStore((state) => state.filters)
  const supporterNameSearch = useSupporterFilteringStore((state) => state.supporterName)

  const hasActiveFilters = activeFilters?.length > 0
  const hasSupporterNameSearch = Boolean(supporterNameSearch)

  const message = (() => {
    if (hasSupporterNameSearch && !hasActiveFilters) {
      return matchingCount === 0
        ? tGroupShow('empty_state.messages.no_results.search_only')
        : tGroupShow('matching_search', { count: matchingCount })
    } else if (!hasSupporterNameSearch && hasActiveFilters) {
      return matchingCount === 0
        ? tGroupShow('empty_state.messages.no_results.filters_only')
        : tGroupShow('matching_filters', { count: matchingCount })
    } else if (hasSupporterNameSearch && hasActiveFilters) {
      return matchingCount === 0
        ? tGroupShow('empty_state.messages.no_results.search_and_filters')
        : tGroupShow('matching_search_and_filters', { count: matchingCount })
    }
  })()

  return (
    <div role="status" aria-busy={searchLoading}>
      {message && (
        <div className="tw:pb-4">
          <Alert type="info" icon="search-lg">
            {message}
          </Alert>
        </div>
      )}
    </div>
  )
}

export default SearchSummaryBar
